// DS: i10.13
import React from 'react';
import IconWrap, { Props } from '../IconWrap';

const Twitch: React.FC<Props> = props => (
  <IconWrap {...props}>
    <svg
      width="0"
      height="0"
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g>
        <path d="M10.363 18.498c.14-.12.22-.184.292-.254.554-.534 1.098-1.078 1.664-1.6a.813.813 0 0 1 .483-.208c1.248-.018 2.496-.006 3.743-.021a.705.705 0 0 0 .433-.183c.771-.725 1.535-1.458 2.282-2.205.12-.12.205-.33.206-.497.013-2.558.005-5.116.015-7.674.001-.277-.081-.348-.361-.348-4.048.008-8.097.008-12.145 0-.276 0-.365.064-.364.345.01 3.42.01 6.84 0 10.26 0 .266.087.342.349.338.917-.011 1.833-.004 2.75-.004.653 0 .653 0 .653.624v1.427M4 18.96V7.129c.025-.05.057-.097.075-.148.347-.994.691-1.987 1.037-2.981h15.87c0 1.412-.004 2.824-.002 4.235.005 1.895.012 3.79.02 5.684.001.222-.026.42-.207.594-1.461 1.406-2.912 2.826-4.376 4.23a.795.795 0 0 1-.485.194c-.829.018-1.658.016-2.487 0a.962.962 0 0 0-.75.308c-.5.504-1.023.987-1.524 1.492a.806.806 0 0 1-.641.263c-.633-.017-1.268-.006-1.902-.007-.103 0-.207-.011-.338-.019v-.333c0-.483-.003-.966.002-1.45.002-.158-.039-.248-.226-.247-1.355.009-2.71.01-4.066.015" />
        <path d="M12.942 11.615c0 .65-.008 1.299.005 1.948.004.201-.061.288-.327.278-.39-.014-.782-.008-1.173-.002-.203.003-.29-.057-.288-.227.004-1.336.005-2.672-.001-4.01 0-.189.105-.236.316-.232.39.008.783.009 1.173-.001.225-.005.301.06.299.242-.01.668-.004 1.336-.004 2.004M17.417 11.606c0 .648-.007 1.297.004 1.945.004.205-.059.305-.356.29-.374-.02-.753-.012-1.13-.003-.205.006-.305-.044-.303-.217.002-1.343.002-2.686 0-4.028-.002-.17.096-.226.302-.223.388.006.778.011 1.165-.001.256-.008.323.08.322.264-.01.657-.004 1.316-.004 1.973" />
      </g>
    </svg>
  </IconWrap>
);
Twitch.displayName = 'Twitch';

export default Twitch;
